/* Lavender Farm Simulator — Phase 5: characters, real-farm tie-in, Prestige Mode.
   1. Characters: Finnegan and the barn cats say one short line when you open the Barn, Processing Works,
      Farm Life or Companions (Huckleberry already greets you in the weekly report).
   2. "Grow this for real": the Crop planner links the selected cultivar to its real plant page in the shop,
      only when that page exists. A link, never a pop-up.
   3. Prestige Mode (level 100): pass the farm to the next generation and start fresh in a famous lavender
      region. Level, coins, field and buildings reset; the Almanac, Cultivar Atlas, achievements and every
      prestige emblem are kept. Each generation adds an emblem, a title and a small starting-coins bonus.
      A full copy of the farm is saved first, and the last prestige can be undone for 14 days.
   Only the prestige steps change the save, and only after the player confirms. */
(function () {
  'use strict';
  if (window.__gllfSimLegacy) return;
  window.__gllfSimLegacy = true;

  var BASE = ((document.currentScript && document.currentScript.src) || '').replace(/gllf-sim-legacy\.js.*$/, '');
  if (BASE && !document.querySelector('link[href*="gllf-sim-legacy.css"]')) {
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = BASE + 'gllf-sim-legacy.css'; document.head.appendChild(l);
  }
  function art(id) { return BASE + 'gllf-art-' + id + '.webp'; }
  function root() { return document.getElementById('lfg-simulator-root'); }
  function api() { var r = root(); return r && r._lfg; }
  function st() { var A = api(); try { return A ? A.state() : null; } catch (e) { return null; } }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); return true; } catch (e) { return v === undefined ? null : false; } }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }

  /* ================= 1. characters ================= */
  var SAYS = {
    barn: ['🐕 Finnegan: I guard the drying racks. Mostly from the cats.', '🐈 Barn cat: *stretches across the lavender bundles* This is my spot now.', '🐕 Finnegan: Upside-down bundles, dark corner, good airflow. I’ve been listening.'],
    processingworks: ['🐕 Finnegan: The still smells like a whole field at once. I love it here.', '🐈 Barn cat: Oil bottles are for knocking over. Kidding. Mostly.', '🐕 Finnegan: Lavandin for oil, English lavender for the kitchen. Huckleberry told me.'],
    life: ['🐕 Finnegan: Rest day? I’ll rest too. Right here. On your feet.', '🐈 Barn cats: We supervise napping. It’s important work.'],
    companions: ['🐕 Finnegan: Huckleberry herds the chickens. I herd Huckleberry.', '🐈 Barn cats: We keep the mice out of the seed. You’re welcome.']
  };
  function sayLine() {
    var r = root(), s = st(); if (!r || !s) return;
    Object.keys(SAYS).forEach(function (v) {
      var view = r.querySelector('#lfg-view-' + v); if (!view || !view.classList.contains('active')) return;
      var head = view.querySelector(':scope > .lfg-page-head'); if (!head) return;
      var el = view.querySelector(':scope > .gpr-say');
      var line = SAYS[v][(+s.week || 0) % SAYS[v].length];
      if (!el) { el = document.createElement('p'); el.className = 'gpr-say'; head.insertAdjacentElement('afterend', el); }
      if (el.textContent !== line) el.textContent = line;
    });
  }

  /* ================= 2. grow this for real ================= */
  var product = {};
  function realLink() {
    var r = root(), s = st(); if (!r || !s || !s.crop) return;
    var card = r.querySelector('#lfg-field-planner'); if (!card) return;
    var h = String(s.crop), a = card.querySelector('.gpr-real');
    if (product[h] === undefined) {
      product[h] = null;
      fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (x) { return x.ok ? x.json() : null; }).then(function (p) { product[h] = p ? { url: '/products/' + h, title: p.title } : false; realLink(); }).catch(function () { product[h] = false; });
      return;
    }
    var p = product[h];
    if (!p) { if (a) a.remove(); return; }
    var name = ((s.plants || []).filter(function (x) { return x && x.id === h; })[0] || {}).name || String(p.title || '').split(/ lavender| plants| –| -/i)[0] || 'this cultivar';
    if (!a) { a = document.createElement('a'); a.className = 'gpr-real'; a.target = '_blank'; a.rel = 'noopener'; card.appendChild(a); }
    if (a.getAttribute('href') !== p.url) { a.href = p.url; }
    var txt = '🪴 Grow ' + name + ' for real →';
    if (a.textContent !== txt) a.textContent = txt;
  }

  /* ================= 3. prestige ================= */
  var GENS = [
    null,
    { n: 1, icon: '🌱', title: 'First Grower', place: 'Your home farm' },
    { n: 2, icon: '🥉', title: 'Sequim Grower', place: 'Sequim, WA', zip: '98382', note: 'the Lavender Capital of North America' },
    { n: 3, icon: '🍐', title: 'Gorge Grower', place: 'Hood River, OR', zip: '97031', note: 'orchard country in the Columbia Gorge' },
    { n: 4, icon: '🌄', title: 'Ojai Grower', place: 'Ojai, CA', zip: '93023', note: 'dry California summers' },
    { n: 5, icon: '⭐', title: 'Hill Country Grower', place: 'Blanco, TX', zip: '78606', note: 'the Lavender Capital of Texas' },
    { n: 6, icon: '🍒', title: 'Up North Grower', place: 'Traverse City, MI', zip: '49684', note: 'lake-effect Michigan winters' },
    { n: 7, icon: '⛰️', title: 'Western Slope Grower', place: 'Paonia, CO', zip: '81428', note: 'high-desert sun and cold nights' },
    { n: 8, icon: '⛴️', title: 'Island Grower', place: 'Friday Harbor, WA', zip: '98250', note: 'San Juan Islands sea air' },
    { n: 9, icon: '🏔️', title: 'Blue Ridge Grower', place: 'Asheville, NC', zip: '28801', note: 'humid mountain summers' },
    { n: 10, icon: '🥇', title: 'Door County Grower', place: 'Sister Bay, WI', zip: '54234', note: 'Lake Michigan’s thumb' },
    { n: 11, icon: '👑', title: 'Prestige Master', place: 'Anywhere you choose', note: 'every region, your way' }
  ];
  function gen(n) { return GENS[Math.min(Math.max(n, 1), GENS.length - 1)]; }
  var KEY = 'gllfPrestigeV1', BACKUP = 'gllfPrestigeBackupV1', CAP = 100;
  function info() {
    var s = st(), a = null, b = null;
    try { a = JSON.parse(ls(KEY) || 'null'); } catch (e) {}
    b = s && s.gllfPrestige;
    var pick = (b && (!a || (+b.gen || 1) >= (+a.gen || 1))) ? b : a;
    return pick && pick.gen ? pick : { gen: 1, history: [] };
  }
  function bonus(g) { return Math.min(g - 1, 5) * 10; }
  function backupInfo() { try { var b = JSON.parse(ls(BACKUP) || 'null'); return b && b.save && Date.now() - b.at < 14 * 864e5 ? b : null; } catch (e) { return null; } }

  function panelHtml(s) {
    var p = info(), g = +p.gen || 1, cur = gen(g), nxt = gen(g + 1), ready = (+s.level || 0) >= CAP, bk = backupInfo();
    var hist = (p.history || []).slice(-10).map(function (h) { var G = gen(h.gen); return '<li><span aria-hidden="true">' + G.icon + '</span> <b>Generation ' + h.gen + '</b> · ' + esc(h.place || G.place) + ' · reached level ' + esc(h.level) + '</li>'; }).join('');
    return '<div class="gpr__top"><div class="gpr__emblem" aria-hidden="true">' + cur.icon + '</div><div><small>Prestige · Farm family</small><h3>Generation ' + g + ': ' + esc(cur.title) + '</h3><p>' +
      (ready ? 'You reached level ' + CAP + '. Pass the farm to the next generation and start fresh in <b>' + esc(nxt.place) + '</b>' + (nxt.note ? ', ' + esc(nxt.note) : '') + '.'
        : 'At level ' + CAP + ' you can pass the farm to the next generation and start fresh in a famous lavender region. You’re level ' + esc(s.level) + '.') + '</p></div></div>' +
      '<div class="gpr__cols"><div><b>Resets</b><p>Level, coins, field, buildings and inventory.</p></div><div><b>Kept forever</b><p>Grower’s Almanac, Cultivar Atlas, achievements and every emblem.</p></div><div><b>Generation ' + (g + 1) + ' rewards</b><p>' + nxt.icon + ' “' + esc(nxt.title) + '” emblem and title, and +' + bonus(g + 1) + '% starting coins.</p></div></div>' +
      '<div class="gpr__row">' + (ready ? '<button type="button" class="gpr-btn" data-gpr-start>Start Generation ' + (g + 1) + ' →</button>' : '<span class="gpr__lock">🔒 Unlocks at level ' + CAP + '</span>') +
      (bk ? '<button type="button" class="gpr-btn gpr-btn--soft" data-gpr-undo>Undo last prestige</button>' : '') + '</div>' +
      (hist ? '<details class="gpr__hist"><summary>Family record</summary><ul>' + hist + '</ul></details>' : '');
  }
  function panel() {
    var r = root(), s = st(); if (!r || !s) return;
    /* Farm Legacy at level 100, and Records (open from day one) so a new generation can always find Undo */
    ['legacy', 'records'].forEach(function (id) { var v = r.querySelector('#lfg-view-' + id); if (v) panelIn(v, s); });
  }
  function panelIn(v, s) {
    var head = v.querySelector(':scope > .lfg-page-head');
    var el = v.querySelector(':scope > .gpr');
    if (!el) {
      el = document.createElement('section'); el.className = 'gpr'; el.setAttribute('aria-label', 'Prestige');
      if (head) head.insertAdjacentElement('afterend', el); else v.insertBefore(el, v.firstChild);
      el.addEventListener('click', function (e) { if (e.target.closest('[data-gpr-start]')) confirmStart(); else if (e.target.closest('[data-gpr-undo]')) confirmUndo(); });
    }
    var html = panelHtml(s); if (el.getAttribute('data-h') !== html) { el.setAttribute('data-h', html); el.innerHTML = html; }
  }

  function dialog(inner, onClick) {
    var el = document.createElement('div'); el.className = 'gpr-dlg'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true');
    el.innerHTML = '<div class="gpr-dlg__card"><button type="button" class="gpr-x" data-gpr-close aria-label="Close">✕</button>' + inner + '</div>';
    document.body.appendChild(el);
    function close() { el.remove(); document.removeEventListener('keydown', key, true); }
    function key(e) { if (e.key === 'Escape') { e.preventDefault(); close(); } }
    document.addEventListener('keydown', key, true);
    el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('[data-gpr-close]')) return close(); onClick(e, close, el); });
    setTimeout(function () { var f = el.querySelector('input, button:not(.gpr-x)'); if (f) f.focus(); }, 40);
    return el;
  }

  function confirmStart() {
    var s = st(); if (!s || (+s.level || 0) < CAP) return;
    var g = +info().gen || 1, nxt = gen(g + 1);
    dialog('<small class="gpr-kicker">Prestige</small><h2>Start Generation ' + (g + 1) + '?</h2>' +
      '<p>Your family passes this farm on and starts a new one in <b>' + esc(nxt.place) + '</b>.</p>' +
      '<ul class="gpr-list"><li>❌ <b>Resets:</b> level ' + esc(s.level) + ' → 1, ' + Math.round(+s.coins || 0).toLocaleString('en-US') + ' coins, your field, buildings and inventory.</li>' +
      '<li>✅ <b>Kept:</b> Grower’s Almanac, Cultivar Atlas, achievements and emblems.</li>' +
      '<li>🎁 <b>New:</b> ' + nxt.icon + ' “' + esc(nxt.title) + '” emblem and +' + bonus(g + 1) + '% starting coins.</li>' +
      '<li>💾 A full copy of this farm is saved first. You can undo for 14 days.</li></ul>' +
      '<label class="gpr-check"><input type="checkbox" data-gpr-ok> I understand my level, coins, field and buildings will reset.</label>' +
      '<div class="gpr__row"><button type="button" class="gpr-btn" data-gpr-go disabled>Start Generation ' + (g + 1) + '</button><button type="button" class="gpr-btn gpr-btn--soft" data-gpr-export>Also download a backup file</button></div>',
      function (e, close, el) {
        if (e.target.closest('[data-gpr-ok]')) el.querySelector('[data-gpr-go]').disabled = !e.target.checked;
        else if (e.target.closest('[data-gpr-export]')) { try { api().exportSave(); } catch (x) {} }
        else if (e.target.closest('[data-gpr-go]') && el.querySelector('[data-gpr-ok]').checked) { close(); doPrestige(); }
      });
  }

  function doPrestige() {
    var A = api(), s = st(); if (!A || !s) return;
    var p = info(), g = +p.gen || 1, nxt = gen(g + 1);
    var saveText; try { saveText = JSON.stringify(s); } catch (e) { return alertBox('Prestige didn’t start', 'The farm couldn’t be copied. Nothing was changed.'); }
    if (!ls(BACKUP, JSON.stringify({ at: Date.now(), gen: g, save: saveText }))) {
      try { A.exportSave(); } catch (e) {}
      return alertBox('Prestige didn’t start', 'This browser is out of room for the safety copy, so nothing was changed. A backup file was offered for download — keep it, then try again.');
    }
    var record = { gen: g + 1, history: (p.history || []).concat([{ gen: g, place: s.place, level: s.level, year: s.year, at: new Date().toISOString().slice(0, 10) }]) };
    var alm = s.gllfAlmanac;
    var ok = false; try { ok = A.startOver('api') !== false; } catch (e) { ok = false; }
    if (!ok) { lsDel(BACKUP); return; }   /* the game already explained why and left the farm as it was */
    var n = st();
    n.gllfPrestige = record; if (alm) n.gllfAlmanac = alm;
    var b = bonus(g + 1); if (b && isFinite(+n.coins)) n.coins = Math.round(+n.coins * (1 + b / 100));
    try { A.save(); } catch (e) {} try { A.render(); } catch (e) {}
    ls(KEY, JSON.stringify(record));
    /* the game reloads the page to open the fresh farm, so the celebration waits for the next page load */
    try { sessionStorage.setItem('gllfPrestigeCelebrate', String(g + 1)); } catch (e) {}
    setTimeout(function () { try { sessionStorage.removeItem('gllfPrestigeCelebrate'); } catch (e) {} celebrate(nxt); }, 3000);   /* if the page didn't reload */
  }

  function celebrate(G) {
    dialog('<div class="gpr-cele"><div class="gpr__emblem gpr__emblem--big" aria-hidden="true">' + G.icon + '</div><small class="gpr-kicker">Generation ' + G.n + ' begins</small><h2>' + esc(G.title) + '</h2>' +
      '<p>A new farm in <b>' + esc(G.place) + '</b>' + (G.note ? ', ' + esc(G.note) : '') + '. Everything you learned comes with you.</p>' +
      '<div class="gpr__row">' + (G.zip ? '<button type="button" class="gpr-btn" data-gpr-here>Set up my ' + esc(G.place.split(',')[0]) + ' farm →</button>' : '<button type="button" class="gpr-btn" data-gpr-here>Choose where to grow →</button>') + '<button type="button" class="gpr-btn gpr-btn--soft" data-gpr-close>Later</button></div></div>',
      function (e, close) {
        if (!e.target.closest('[data-gpr-here]')) return;
        close(); if (!window.GLLFPlot) return;
        window.GLLFPlot.open();
        if (G.zip) setTimeout(function () {
          var box = document.querySelector('.gplot-box'), inp = box && box.querySelector('input:not([type="checkbox"])');
          if (!inp) return; inp.value = G.zip; inp.dispatchEvent(new Event('input', { bubbles: true }));
          var go = box.querySelector('.gplot-primary'); if (go) go.click();
        }, 250);
      });
  }

  function confirmUndo() {
    var bk = backupInfo(); if (!bk) return;
    dialog('<small class="gpr-kicker">Prestige</small><h2>Undo the last prestige?</h2><p>This brings back your Generation ' + esc(bk.gen) + ' farm exactly as it was on ' + esc(new Date(bk.at).toLocaleDateString()) + '. Anything done on the new farm since then will be replaced.</p>' +
      '<div class="gpr__row"><button type="button" class="gpr-btn" data-gpr-restore>Bring back my farm</button><button type="button" class="gpr-btn gpr-btn--soft" data-gpr-close>Keep the new farm</button></div>',
      function (e, close) { if (e.target.closest('[data-gpr-restore]')) { close(); restore(bk); } });
  }
  function restore(bk) {
    var A = api(), s = st(); if (!A || !s) return;
    var old; try { old = JSON.parse(bk.save); } catch (e) { return; }
    var alm = s.gllfAlmanac;
    Object.keys(s).forEach(function (k) { if (!(k in old)) delete s[k]; });
    Object.keys(old).forEach(function (k) { s[k] = old[k]; });
    if (alm) s.gllfAlmanac = alm;
    try { A.save(); } catch (e) {} try { A.render(); } catch (e) {}
    var rec = old.gllfPrestige || { gen: bk.gen, history: (info().history || []).slice(0, -1) };
    ls(KEY, JSON.stringify(rec)); lsDel(BACKUP);
    alertBox('Your farm is back', 'Generation ' + bk.gen + ' is restored, level ' + esc(old.level) + '.');
  }
  function alertBox(t, m) { dialog('<h2>' + esc(t) + '</h2><p>' + m + '</p><div class="gpr__row"><button type="button" class="gpr-btn" data-gpr-close>OK</button></div>', function () {}); }

  window.GLLFPrestige = { info: info, gen: gen };
  (function boot(n) {
    if (!st()) { if (n < 240) setTimeout(function () { boot(n + 1); }, 250); return; }
    function tick() { try { sayLine(); } catch (e) {} try { realLink(); } catch (e) {} try { panel(); } catch (e) {} }
    tick(); setInterval(tick, 2000);
    document.addEventListener('lfg:route-enter', function () { setTimeout(tick, 600); }, true);
    var cele = null; try { cele = sessionStorage.getItem('gllfPrestigeCelebrate'); sessionStorage.removeItem('gllfPrestigeCelebrate'); } catch (e) {}
    if (cele && !document.querySelector('.gpr-dlg')) setTimeout(function () {
      /* a fresh farm otherwise reopens on whatever page the old farm was on (often the Prayer Barn); start on the Farm Map */
      var r = root(), hub = r && r.querySelector('[data-hub="farm"]'); if (hub) hub.click();
      setTimeout(function () { var t = r && r.querySelector('#lfg-hub-pages [data-tab="world"]'); if (t) t.click(); }, 300);
      celebrate(gen(+cele));
    }, 1200);
  })(0);
})();
